import { notification } from 'antd';
import { useCurrentUserQuery } from 'api';
import { Col, Layout, Row } from 'components';
import { ADMIN_ROUTES, WAREHOUSE_ROUTES } from 'constants/routes';
import { Outlet, useNavigate } from 'react-router-dom';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import React, { createContext, useEffect } from 'react';
import { NotificationInstance } from 'antd/es/notification/interface';
import { isWarehouseUser } from '../../../../utils/routeGuards';
import styles from './styles.module.scss';

export const NotificationContext = createContext<NotificationInstance | null>(null);

export const AdminLayout = React.memo(() => {
  const navigate = useNavigate();
  const userId = JSON.parse(localStorage.getItem('userId') || 'null');
  const { isError, error = {}, isLoading } = useCurrentUserQuery({ userId });
  const [notificationApi, contextHolder] = notification.useNotification();

  useEffect(() => {
    if (isError && (error as FetchBaseQueryError)?.status === 401) {
      navigate(ADMIN_ROUTES.adminSignIn);
      return;
    } else if (isError && (error as FetchBaseQueryError)?.status === 'FETCH_ERROR') {
      navigate(ADMIN_ROUTES.adminSignIn);
      return;
    }
    // Check if user is a warehouse user trying to access admin using the new route guard
    if (isWarehouseUser()) {
      // Redirect warehouse users to their profile page
      navigate(WAREHOUSE_ROUTES.inboundPackages);
      return;
    }
  }, [isError, error, navigate]);
  return (
    <NotificationContext.Provider value={notificationApi}>
      {contextHolder}
      <Layout className={styles.layout}>
        <Row className={styles.web_layout}>
          <Col span={24}>{!isLoading && <Outlet />}</Col>
        </Row>
      </Layout>
    </NotificationContext.Provider>
  );
});
